import React, { useRef, useState, useCallback } from "react";

/**
 * Hero video with an always-muted-by-default auto-play and a small
 * unmute toggle so a viewer can hear the sound on demand. British copy.
 */
export function HeroVideo() {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);

  const toggle = useCallback(() => {
    const v = ref.current;
    if (!v) return;
    const next = !v.muted;
    v.muted = next;
    // If we just unmuted, make sure it is actually playing.
    if (!next) {
      const p = v.play();
      if (p && typeof p.then === "function") p.catch(() => {});
    }
    setMuted(next);
  }, []);

  return (
    <div className="mkt-hero-video" data-testid="mkt-hero-video">
      <div className="mkt-hero-video-frame">
        <video
          ref={ref}
          className="mkt-hero-video-el"
          src="/media/crowther-hero.mp4"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          poster="/logos/mark-seafoam.png"
          aria-label="Crowther sovereign stack film"
        />
        <button
          type="button"
          onClick={toggle}
          className={`mkt-hero-video-sound ${muted ? "muted" : "on"}`}
          data-testid="mkt-hero-video-sound-toggle"
          aria-pressed={!muted}
          aria-label={muted ? "Play sound" : "Mute sound"}
        >
          {muted ? (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
              <path d="M11 5L6 9H3v6h3l5 4V5z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" strokeLinecap="round" fill="none"/>
              <path d="M17 9l4 6M21 9l-4 6" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/>
            </svg>
          ) : (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
              <path d="M11 5L6 9H3v6h3l5 4V5z" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" strokeLinecap="round" fill="none"/>
              <path d="M16 8.5a5 5 0 010 7M19 6a8 8 0 010 12" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/>
            </svg>
          )}
          <span className="mkt-hero-video-sound-label">
            {muted ? "Play sound" : "Mute"}
          </span>
        </button>
      </div>
      <div className="mkt-hero-video-cap">
        <span className="mkt-hero-video-cap-eyebrow">FILM &nbsp;·&nbsp; SOVEREIGN STACK</span>
        <p className="mkt-hero-banner-copy">
          One sovereign stack, owned from the compute up to the governed platform. Deployed in-country, on ground you control, and handed over for you to run.
        </p>
      </div>
    </div>
  );
}
